module.exports = __webpack_public_path__ + "static/media/kaserne.750aef4d.svg";